import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import useHash from '../../hooks/useHash'
import Breadcrumb from '../../components/breadcrumb/breadcrumb'
import Hero from '../../components/hero-v2/hero'
import Helmet from 'react-helmet';
import Layout from '../../components/layouts/layout'
import { default as TratamientoTransferencia } from './tratamiento-y-transferencia'
import { default as TratamientoDatos } from './tratamiento-de-los-datos'
import { default as UsoCookies } from './uso-de-cookies'
import { default as EjercicioDerechos } from './ejercicio-de-derechos'
import { default as NuestrosSistemas } from './nuestros-sistemas-de-videovigilancia'
import { default as CampanaComunicacion } from './campana-de-comunicacion'
import { default as PautasNavegacion } from './pautas-para-una-navegacion-segura'
import { default as EmpresasSocios } from './empresas-y-socios'
import s from './index.module.css'
import { withPrefix } from 'gatsby';

const isBrowser = typeof window !== 'undefined'

const typesPolicy = [ 
  {
    index: 0,
    hash: 'tratamiento-y-transferencia-de-tus-datos-personales',
    image: withPrefix('/images/woman-circle.svg'),
    title: 'Tratamiento y transferencia de tus datos personales',
    content: <TratamientoTransferencia />
  },
  {
    index: 1,
    hash: 'tratamiento-de-los-datos-personales-de-menores-de-edad',
    image: withPrefix('/images/document-circle.svg'),
    title: 'Tratamiento de los datos personales de menores de edad',
    content: <TratamientoDatos />
  },
  {
    index: 2,
    hash: 'uso-de-cookies',
    image: withPrefix('/images/cookie_circle.svg'),
    title: 'Uso de cookies',
    content: <UsoCookies />
  },
  {
    index: 3,
    hash: 'ejercicio-de-derechos-por-el-titular-de-datos-personales',
    image: withPrefix('/images/id_card.svg'),
    title: 'Ejercicio de derechos por el titular de datos personales',
    content: <EjercicioDerechos />
  },
  {
    index: 4,
    hash: 'nuestros-sistemas-de-videovigilancia',
    image: withPrefix('/images/surveillance_camera.svg'),
    title: 'Nuestros sistemas de videovigilancia',
    content: <NuestrosSistemas />
  },
  {
    index: 5,
    hash: 'campana-de-comunicacion',
    image: withPrefix('/images/megaphone.svg'),
    title: 'Campaña de comunicación',
    content: <CampanaComunicacion />
  },
  {
    index: 6,
    hash: 'pautas-para-una-navegacion-segura',
    image: withPrefix('/images/secure_website.svg'),
    title: 'Pautas para una navegación segura',
    content: <PautasNavegacion />
  },
  {
    index: 7,
    hash: 'empresas-y-socios-comerciales',
    image: withPrefix('/images/crossing_hands.svg'),
    title: 'Empresas y Socios comerciales',
    content: <EmpresasSocios />
  }
]

const settingsCarousel = {
  className: `${s.sliderVerticalItem}`,
  vertical: true,
  dots: false,
  slidesToShow: 9,
  slidesToScroll: 1,
  autoplay: false,
  slide: 'div',
  autoplaySpeed: 20000,
  initialSlide: 0,
  centerMode: false,
  infinite: false,
  appendDots: dots => <ul style={{ bottom: '-35px' }}>{dots}</ul>,
  customPaging: i => <span className='ft-slick__dots--custom'></span>,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 9,
        slidesToScroll: 1,
        dots: false,
        vertical: true,
        infinite: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: true,
        vertical: false,
        centerMode: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        vertical: false,
        centerMode: true
      }
    },
  ]
}

const Sidebar = props => (
  <Slider {...settingsCarousel}>
    {typesPolicy.map((item,index) => (
    <div key={item.title} className={`tw-py-2 tw-pr-2@lg tw-pt-2@lg tw-pb-0@lg tw-px-2 tw-px-0@lg`}>
      <div
        className={`${s.layoutTabNavItem} ${props.typeContent === index ? s.active : ''} `}
        onClick={() => props.handleClick(index)}
      >
        <img
          src={item.image}
          alt=''
          className={`${s.layoutTabNavItemIco}`}
        />
        <div
          className={`${s.layoutTabNavItemText} font-family-secondary c-gray--4 fw-6 tw-f-14 tw-f-16@lg`}
        >
          {item.title}
        </div>
      </div>
    </div>
    ))}
  </Slider>
)

const Content = props => {
  let itemTypeContent = typesPolicy.filter((_,index) => (index === props.typeContent))
  return(
    <div className={`${s.layoutTabContent}`}>
      {itemTypeContent.map((item,_) => (    
          <div key={item.title}>
          {item.content}
          </div>
      ))}
    </div>
  )
}

const PoliticaPrivacidad = () => {
  const titlesBreadcrumb = {
    titleFinal: 'Políticas de privacidad'
  }
  
  const [TypeContentCurrent, setTypeContentCurrent] = useState(0)
  const [hash, setHash] = useHash()

  const goTabTypeContent = t => {
    setTypeContentCurrent(t)
    setHash(typesPolicy[t].hash)
  }

  const goHashTypeContent = () => {
    if(!isBrowser) {
      return
    }
    let getHashCurrent = window.location.hash.split('#')[1]
    let itemFounded = typesPolicy.filter((item, i) => item.hash === getHashCurrent)
    if(itemFounded.length) {
      goTabTypeContent(itemFounded[0].index)
    }
  }

  useEffect(() => {
    goHashTypeContent()
  }, [hash])

  return (
    <Layout>
      <Helmet>
        <title>Tu Información Segura: Política de Privacidad | Prima AFP</title>
        <meta name="title" content="Tu Información Segura: Política de Privacidad | Prima AFP" data-react-helmet="true"/>
        <meta name='description' content='Encuentra aqui detalles respecto a la politica de privacidad de Prima AFP' data-react-helmet="true" />
        <link rel="canonical" href="https://www.prima.com.pe/public-zone/politica-de-privacidad/"></link>
      </Helmet>
      <Hero
          title="Políticas de privacidad"
          image={
          'sobre-prima-afp/politica-de-privacidad/banner-politica-de-privacidad-desktop.svg'
          }
          imageMobile={
          'sobre-prima-afp/politica-de-privacidad/banner-politica-de-privacidad-mobile.svg'
          }
          className={`bg-turquoise-1`}
      />

      <Breadcrumb titlesBreadcrumb={titlesBreadcrumb}/>

      <div className={'containerWrap'}>
        <div className={`${s.layoutTab}`}>
          <div className={`${s.layoutTabNav}`}>
            <Sidebar typeContent={TypeContentCurrent} handleClick={goTabTypeContent} />
          </div>
          <div className='tw-mt-4'>
            <Content typeContent={TypeContentCurrent} />
          </div>
        </div>
      </div>

    </Layout>
  )
}

export default PoliticaPrivacidad
